module.exports = __webpack_public_path__ + "static/media/no-data.7963074c.svg";